import VideoCover from "../assets/palms-images/palms-construction.avif";

const generateGallery = (folderPath, count, extension = ".jpg") => {
  return Array.from({ length: count }, (_, i) => `${folderPath}/${i + 1}${extension}`);
};

export const palmsFeatures = [
  {
    title: "Construction Progress",
    cover: "/Palms-Construction-Progress/Images/Palms-April/1.JPG",
    type: "folder",
    folders: [
      {
        title: "April 2026 Update",
        cover: "/Palms-Construction-Progress/Images/Palms-April/1.JPG",
        gallery: generateGallery("/Palms-Construction-Progress/Images/Palms-April", 10, ".JPG"),
      },
      {
        title: "March 2026 Update",
        cover: "/Palms-Construction-Progress/Images/Palms-Mar/1.JPG",
        gallery: generateGallery("/Palms-Construction-Progress/Images/Palms-Mar", 23, ".JPG"),
      },
      {
        title: "February 2026 Update",
        cover: "/Palms-Construction-Progress/Images/Palms-Feb/1.jpg",
        gallery: generateGallery("/Palms-Construction-Progress/Images/Palms-Feb", 20, ".jpg"),
      },
      {
        title: "January 2026 Update",
        cover: "/Palms-Construction-Progress/Images/Palms-Jan/1.jpg",
        gallery: generateGallery("/Palms-Construction-Progress/Images/Palms-Jan", 14, ".jpg"),
      }
    ]
  },
  {
    title: "Video Gallery",
    cover: VideoCover,
    type: "folder",
    folders: [
      {
        title: "April 2026 Update",
        cover: "/Palms-Construction-Progress/Videos/Palms-April-thumb.png",
        gallery: [
          { type: "video", src: "/Palms-Construction-Progress/Videos/Palms-April.mp4", title: "APRIL 2026 UPDATE" }
        ],
      },
      {
        title: "March 2026 Update",
        cover: "/Palms-Construction-Progress/Videos/Palms-March-thumb.png",
        gallery: [
          { type: "video", src: "/Palms-Construction-Progress/Videos/Palms-March.mp4", title: "MARCH 2026 UPDATE" }
        ],
      },
      {
        title: "February 2026 Update",
        cover: "/Palms-Construction-Progress/Videos/Palms-February-thumb.png",
        gallery: [
          { type: "video", src: "/Palms-Construction-Progress/Videos/Palms-February.mp4", title: "FEBRUARY 2026 UPDATE" }
        ],
      },
      {
        title: "January 2026 Update",
        cover: "/Palms-Construction-Progress/Videos/Palms-January-thumb.png",
        gallery: [
          { type: "video", src: "/Palms-Construction-Progress/Videos/Palms-January.mp4", title: "JANUARY 2026 UPDATE" }
        ],
      }

    ]
  },
];
